import commonMessage from 'root/common/messages';

export function allGroup(intl) {
  return {
    chart: [
      {
        id: 'LineChart',
        ctrlType: { type: 'LineChart', config: { isCanvas: true } },
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.LineChart)
      },
      {
        id: 'SplineChart',
        ctrlType: { type: 'SplineChart', config: { isCanvas: true } },
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.SplineChart)
      },
      {
        id: 'Column',
        ctrlType: { type: 'Column', config: { isCanvas: true } },
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Column)
      },
      {
        id: 'Area',
        ctrlType: { type: 'Area', config: { isCanvas: true } },
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Area)
      },
      {
        id: 'Dashboard',
        ctrlType: { type: 'Dashboard', config: { isCanvas: true } },
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Dashboard)
      },
      {
        id: 'Gauge',
        ctrlType: { type: 'Gauge', config: { isCanvas: true } },
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Gauge)
      },
      {
        id: 'Bubble',
        ctrlType: { type: 'Bubble', config: { isCanvas: true } },
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Bubble)
      },
      {
        id: 'Scatter',
        ctrlType: { type: 'Scatter', config: { isCanvas: true } },
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Scatter)
      },
      {
        id: 'Pie',
        ctrlType: { type: 'Pie', config: { isCanvas: true } },
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Pie)
      },
      {
        id: 'Funnel',
        ctrlType: { type: 'Funnel', config: { isCanvas: true } },
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Funnel)
      },
      {
        id: 'SpiderChart',
        ctrlType: { type: 'SpiderChart', config: { isCanvas: true } },
        defaultWidth: 300,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.SpiderChart)
      },
      {
        id: 'AnnularChart',
        ctrlType: { type: 'AnnularChart', config: { isCanvas: true } },
        defaultWidth: 300,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.AnnularChart)
      },
      {
        id: 'SpcChart',
        ctrlType: { type: 'SpcChart', config: { isCanvas: true } },
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.SpcChart)
      },
      {
        id: 'BarChart',
        ctrlType: { type: 'BarChart', config: { isCanvas: true } },
        defaultWidth: 300,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.BarChart)
      },
      {
        id: 'ProgressChart',
        ctrlType: { type: 'ProgressBar' },
        displayName: intl.formatMessage(commonMessage.Progress)
      }
    ],
    form: [
      {
        id: 'LineCtrl',
        ctrlType: 'LineCtrl',
        displayName: intl.formatMessage(commonMessage.LineCtrl),
        defaultWidth: 168,
        defaultHeight: 32

      },
      {
        id: 'LabelCtrl',
        ctrlType: { type: 'LabelCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.LabelCtrl),
        defaultWidth: 168,
        defaultHeight: 32

      },
      {
        id: 'HiddenFieldCtrl',
        ctrlType: { type: 'HiddenFieldCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.HiddenFieldCtrl),
        defaultWidth: 56,
        defaultHeight: 56

      },
      {
        id: 'InputCtrl',
        ctrlType: { type: 'InputCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.InputCtrl),
        defaultWidth: 348,
        defaultHeight: 32

      },
      {
        id: 'SelectCtrl',
        ctrlType: { type: 'SelectCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.SelectCtrl),
        defaultWidth: 348,
        defaultHeight: 32

      },
      {
        id: 'CascaderCtrl',
        ctrlType: { type: 'CascaderCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.CascaderCtrl),
        defaultWidth: 348,
        defaultHeight: 32

      },
      {
        id: 'RadioCtrl',
        ctrlType: { type: 'RadioCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.RadioCtrl),
        defaultWidth: 348,
        defaultHeight: 32

      },
      {
        id: 'CheckboxCtrl',
        ctrlType: { type: 'CheckboxCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.CheckboxCtrl),
        defaultWidth: 348,
        defaultHeight: 32

      },
      {
        id: 'DatePickerCtrl',
        ctrlType: { type: 'DatePickerCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.DatePickerCtrlLabel),
        defaultWidth: 348,
        defaultHeight: 32

      },
      {
        id: 'ButtonCtrl',
        ctrlType: { type: 'ButtonCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.ButtonCtrl),
        defaultWidth: 120,
        defaultHeight: 36

      },
      {
        id: 'TreeCtrl',
        ctrlType: { type: 'TreeCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.TreeCtrl),
        defaultWidth: 200,
        defaultHeight: 290

      },
      {
        id: 'SingleList',
        ctrlType: { type: 'SingleList', group: 'form' },
        displayName: intl.formatMessage(commonMessage.SingleList),
        defaultWidth: 180,
        defaultHeight: 333

      },
      {
        id: 'TableCtrl',
        ctrlType: { type: 'TableCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.TableCtrl),
        defaultWidth: 586,
        defaultHeight: 300

      },
      {
        id: 'UploadImg',
        ctrlType: { type: 'UploadImg', group: 'form' },
        displayName: intl.formatMessage(commonMessage.UploadImg),
        defaultWidth: 200,
        defaultHeight: 200

      },
      {
        id: 'TabsCtrl',
        ctrlType: { type: 'TabsCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.TabsCtrl),
        defaultWidth: 300,
        defaultHeight: 300

      },
      {
        id: 'UploadCtrl',
        ctrlType: { type: 'UploadCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.UploadCtrl),
        defaultWidth: 120,
        defaultHeight: 120

      },
      {
        id: 'BreadcrumbCtrl',
        ctrlType: { type: 'BreadcrumbCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.crumbs),
        defaultWidth: 400,
        defaultHeight: 100

      },
      {
        id: 'SearchCtrl',
        ctrlType: { type: 'SearchCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.search),
        defaultWidth: 348,
        defaultHeight: 32
      },

      {
        id: 'TimeCtrl',
        ctrlType: { type: 'TimeCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.Time),
        defaultWidth: 348,
        defaultHeight: 32
      },
      {
        id: 'DateCtrl',
        ctrlType: { type: 'DateCtrl', group: 'form' },
        displayName: intl.formatMessage(commonMessage.Date),
        defaultWidth: 348,
        defaultHeight: 32
      }
    ],
    control: [
      {
        id: 'RealAlarm',
        ctrlType: 'RealAlarm',
        defaultWidth: 800,
        defaultHeight: 500,
        displayName: intl.formatMessage(commonMessage.RealAlarm)
      },
      {
        id: 'HistoryAlarm',
        ctrlType: 'HistoryAlarm',
        defaultWidth: 800,
        defaultHeight: 500,
        displayName: intl.formatMessage(commonMessage.HistoryAlarm)
      },
      {
        id: 'VideoCtrl',
        ctrlType: 'VideoCtrl',
        defaultWidth: 400,
        defaultHeight: 300,
        displayName: intl.formatMessage(commonMessage.LiveStreaming)
      },
      {
        id: 'VideoWallCtrl',
        ctrlType: 'VideoWallCtrl',
        defaultWidth: 400,
        defaultHeight: 300,
        displayName: intl.formatMessage(commonMessage.videoWall)
      },
      {
        id: 'TrendChart',
        ctrlType: 'TrendChart',
        defaultWidth: 800,
        defaultHeight: 500,
        displayName: intl.formatMessage(commonMessage.TrendChart)
      },
      {
        id: 'TodoCtrl',
        ctrlType: 'TodoCtrl',
        defaultWidth: 350,
        defaultHeight: 180,
        displayName: intl.formatMessage(commonMessage.TodoCtrl)
      },
      {
        id: 'StartWorkProcessBtn',
        ctrlType: 'StartWorkProcessBtn',
        defaultWidth: 350,
        defaultHeight: 180,
        displayName: intl.formatMessage(commonMessage.StartWorkProcessBtn)
      },
      {
        id: 'ReporterCtrl',
        ctrlType: { type: 'ReporterCtrl', group: 'editor', editorName: 'RepoterDesigner', config: { isCanvas: true } },
        defaultWidth: 600,
        defaultHeight: 400,
        displayName: intl.formatMessage(commonMessage.ReporterCtrl)

      },
      {
        id: 'Webview',
        ctrlType: 'Webview',
        defaultWidth: 640,
        defaultHeight: 480,
        displayName: intl.formatMessage(commonMessage.Webview)

      },
      {
        id: 'StartWorkProcess',
        ctrlType: 'StartWorkProcess',
        defaultWidth: 320,
        defaultHeight: 320,
        displayName: intl.formatMessage(commonMessage.StartWorkProcess)
      },
      {
        id: 'CalendarCtrl',
        ctrlType: 'CalendarCtrl',
        defaultWidth: 520,
        defaultHeight: 520,
        displayName: intl.formatMessage(commonMessage.calendar)
      },
      {
        id: 'CustomComp',
        ctrlType: 'CustomComp',
        defaultWidth: 120,
        defaultHeight: 120,
        displayName: intl.formatMessage(commonMessage.programme)
      },
      {
        id: 'CarouselCtrl',
        ctrlType: 'CarouselCtrl',
        defaultWidth: 120,
        defaultHeight: 120,
        displayName: intl.formatMessage(commonMessage.carousel)
      },
      {
        id: 'HTContainer',
        ctrlType: { type: 'HTContainer', group: 'editor', editorName: 'ProcessFlowChart', config: { isCanvas: true } },
        defaultWidth: 168,
        defaultHeight: 32,
        displayName: intl.formatMessage(commonMessage.htContainer)
      }
    ],
    zone: [
      {
        ctrlType: 'Zone',
        defaultHeight: 32,
        defaultWidth: 168,
        displayName: intl.formatMessage(commonMessage.zone),
        id: 'ZoneCtrl'
      },
      {
        ctrlType: 'Grid',
        defaultHeight: 32,
        defaultWidth: 168,
        displayName: intl.formatMessage(commonMessage.grid),
        id: 'Grid'
      }
    ]
  };
}
